import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/roth-ira-converter',
  component: () => import('../../routes/RothIraConverter.svelte'),
  card: {
    id: 'roth-ira-converter',
    title: 'Roth IRA Converter',
    description: 'Compare converting a traditional IRA to a Roth now vs. waiting. Calculate tax paid upfront vs. lifetime tax savings.',
    icon: 'swap_horiz',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/roth-ira-converter',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Roth IRA Converter Calculator – Convert Traditional IRA to Roth',
    description: 'Free Roth IRA converter calculator to compare taxes paid now vs. in retirement. Calculate whether converting your traditional IRA to a Roth IRA makes sense based on your current and expected tax rates.',
  },
};

export default meta;
